<div class="multiple-tabs d-flex align-items-center justify-content-center">
    <div class="multiple-tabs-modal">
        <p>{{'MULTITABS.TEXT' | translate}}</p>
        <button mat-raised-button color="accent" (click)="useHere()">{{'MULTITABS.USEHERE' | translate}}</button>
    </div>    
</div>